module.exports = __webpack_public_path__ + "static/Roboto-Regular-18d44f79b3979ec168862093208c6d7d.ttf";